import * as React from 'react'; 
export interface IOptions {
    value?: string;
    label?: string;
    date?: string;
}

export interface ISelectOptionComponentProps {
    className?: string;
    isDisabled?: boolean;
    isFocused?: boolean;
    isSelected?: boolean;
    onFocus?: Function;
    onSelect?: Function;
    option: IOptions;
}

export class SelectOptionComponent extends React.PureComponent<ISelectOptionComponentProps, {}> {
    constructor(props: ISelectOptionComponentProps | Readonly<ISelectOptionComponentProps>) {
        super(props);
    }

    handleMouseDown = (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        this.props.onSelect && this.props.onSelect(this.props.option, event);
    }

    handleMouseEnter = (event: any) => {
        this.props.onFocus && this.props.onFocus(this.props.option, event);
    }

    handleMouseMove = (event: any) => {
        if (this.props.isFocused) {
            this.props.onFocus && this.props.onFocus(this.props.option, event);
        }
    }

    render() {
        return (
            <div className={this.props.className}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
            >
                <div
                    style={{ textAlign: 'left', width: '50%', display: 'inline-block' }}
                >
                    {this.props.children || 'NA'}
                </div>
                <div
                    style={{ textAlign: 'right', width: '50%', display: 'inline-block' }}
                >
                    {this.props.option.date}
                </div>
            </div>
        );
    }
}
